module.exports = __webpack_public_path__ + "img/13.6304eba2.png";